/** @jsxImportSource @emotion/react */
import { useState } from 'react';
import { css } from '@emotion/react';
import { LoginCard } from '../../organisms/LoginCard/LoginCard';
import { theme } from '../../../design-system/theme/theme';

/**
 * LoginScreen Props
 *
 * onSubmit: (id, password) => Promise<void> — 로그인 제출 콜백
 * loading: 로딩 중 → 버튼 비활성화
 * error: 에러 메시지 표시
 */
export interface LoginScreenProps {
  onSubmit: (id: string, password: string) => Promise<void>;
  loading?: boolean;
  error?: string | null;
}

const backdropStyle = css`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${theme.color.navBg};
`;

/**
 * 로그인 화면
 * LoginCard 래퍼로 id/pw 입력받아 onSubmit 콜백 호출
 */
export function LoginScreen({
  onSubmit,
  loading = false,
  error = null,
}: LoginScreenProps) {
  // 폼 입력 상태
  const [id, setId] = useState('admin');
  const [pw, setPw] = useState('admin');

  // LoginCard의 onSubmit: 폼 제출 → onSubmit 콜백 호출
  const handleCardSubmit = async () => {
    await onSubmit(id, pw);
  };

  return (
    <div css={backdropStyle}>
      <LoginCard
        title="sam-opendata"
        subtitle="수집 관리 콘솔"
        idValue={id}
        pwValue={pw}
        onChangeId={setId}
        onChangePw={setPw}
        onSubmit={handleCardSubmit}
        footnote=""
      />
      {/* 로딩 중 표시 */}
      {loading && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0,0,0,0.2)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 60,
          }}
        >
          <div style={{ color: '#fff' }}>로그인 중…</div>
        </div>
      )}
      {/* 에러 메시지 */}
      {error && (
        <div
          style={{
            position: 'fixed',
            top: '1rem',
            left: '50%',
            transform: 'translateX(-50%)',
            backgroundColor: '#fee',
            color: '#c00',
            padding: '1rem',
            borderRadius: '0.5rem',
            zIndex: 61,
          }}
        >
          {error}
        </div>
      )}
    </div>
  );
}
